// src/pages/AccessDenied.js
import { Box, Button, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Avatar from '@mui/material/Avatar'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import { useNavigate, useLocation } from 'react-router-dom'

const DEFAULT_MESSAGE = "Cette fonctionnalité n'est pas disponible avec votre abonnement."

const AccessDenied = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [message, setMessage] = useState(DEFAULT_MESSAGE)

  useEffect(() => {
    const fromState = location.state?.denied_message
    const fromStorage = (() => {
      try {
        return localStorage.getItem('denied_message')
      } catch (_) {
        return null
      }
    })()
    const fromQuery = new URLSearchParams(location.search || window.location.search).get('message')
    setMessage(fromState || fromQuery || fromStorage || DEFAULT_MESSAGE)
  }, [location.state, location.search])
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '90vh', // Takes full viewport height
        color: 'text.primary',
        p: 3, // Adds padding for small screens
      }}
    >
      {/* Icon with circular background */}
      <Avatar
        sx={{
          width: 150,
          height: 150,
          bgcolor: '#ffffff2e', // Uses the custom primary color
          mb: 6, // Margin bottom
        }}
      >
        <LockOutlinedIcon sx={{ fontSize: 90, color: 'gray' }} />
      </Avatar>

      {/* Message Text */}
      <Typography
        variant="h6"
        component="p"
        textAlign="center"
        color="white" // Muted text color
        sx={{
          mb: 4, // Margin bottom

          // maxWidth: '450px', // Prevents text from being too wide
        }}
      >
        {message}
      </Typography>

      {/* Action Button */}
      <Button
        variant="contained"
        size="large"
        sx={{
          bgcolor: 'primary.main', // Custom button color
          borderRadius: 2, // Rounded corners
          px: 4, // Horizontal padding
          py: 1.5, // Vertical padding
          fontSize: '1rem',
          '&:hover': {
            bgcolor: '#4a4a6a', // A slightly lighter hover color
          },
        }}
        onClick={() => navigate('/subscription')}
      >
        Mettre à jour mon abonnement
      </Button>
    </Box>
  )
}

export default AccessDenied
